import { getDateTime, getSecurityRuleLabel } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var renderColumns = function renderColumns(translations) {
  var ruleLabels = {
    copyPaste: translations.violateCopyPaste,
    tabSwitch: translations.violateSwitchTab,
    other: '-'
  };
  return [{
    width: '25%',
    title: translations.violateTime,
    dataIndex: 'createAt',
    key: 'createAt',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: getDateTime(parseInt(record.createdAt)) || '-'
      });
    }
  }, {
    width: '25%',
    title: translations.violateType,
    dataIndex: 'securityOptionId',
    key: 'securityOptionId',
    render: function render(_, record) {
      return /*#__PURE__*/_jsx("span", {
        children: getSecurityRuleLabel(record.securityOptionId, ruleLabels, record.message)
      });
    }
  }];
};